import React from "react";
import "./Icons.scss";

const Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon-facebook"
      viewBox="0 0 17 17"
    >
      <g>
        <g className="cls-2">
          <path
            className="cls-3"
            d="M15.86,8.58A7.12,7.12,0,1,1,8.75,1.46a7.11,7.11,0,0,1,7.11,7.12"
          />
          <path
            className="cls-4"
            d="M6.72,11.92H5.2V7H6.72ZM6,6.35a.88.88,0,1,1,.88-.88A.87.87,0,0,1,6,6.35m6.46,5.57H10.9V9.53c0-.56,0-1.29-.8-1.29s-.91.62-.91,1.26v2.42H7.67V7H9.13v.67h0a1.62,1.62,0,0,1,1.44-.79c1.54,0,1.83,1,1.83,2.33Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Icon;
